import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import type { SubmissionStage } from '@/types/submission.types';

interface StatusBadgeProps {
  stage: SubmissionStage;
}

const STAGE_STYLES: Record<SubmissionStage, string> = {
  submitted: 'bg-blue-100 text-blue-800',
  video_pending: 'bg-gray-100 text-gray-800',
  video_completed: 'bg-purple-100 text-purple-800',
  under_review: 'bg-yellow-100 text-yellow-800',
  approved: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
  waitlist: 'bg-orange-100 text-orange-800',
};

export function StatusBadge({ stage }: StatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <span
      className={cn('inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold', STAGE_STYLES[stage])}>
      {t(`submissions.stages.${stage}`)}
    </span>
  );
}
